module.exports = __webpack_public_path__ + "static/media/drunk-slack.c555defa.png";